import config from '@/Constants';
import { HttpStatusCode } from '@/modules/shared/data/protocols/http';
import { UnexpectedError } from '@/modules/shared/domain/errors';
import { AxiosHelper } from '@/modules/shared/infra/protocols/http';

const url = config.DISCUSSION_COMMENT_MEDIAS_URL;

export const deleteCommentMedia = async (mediaId: string): Promise<void> => {
  const { statusCode } = await AxiosHelper.delete({
    url: `${url}/${mediaId}`,
    timeout: 5000,
  });

  if (statusCode === HttpStatusCode.deletedSuccessfully) {
    return;
  }
  throw new UnexpectedError();
};
